import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';

const resources = {
  en: {
    translation: enTranslations,
  },
  es: {
    translation: esTranslations,
  },
};

// Get initial language from settings store if available
const getInitialLanguage = () => {
  try {
    const settingsStorage = localStorage.getItem('settings-storage');
    if (settingsStorage) {
      const settings = JSON.parse(settingsStorage);
      if (settings.state?.language) {
        return settings.state.language;
      }
    }
  } catch (error) {
    console.warn('Failed to get language from settings store:', error);
  }
  return 'en'; // fallback
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    debug: import.meta.env.DEV,
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: [], // Don't cache in localStorage, let the store handle it
    },
    
    // Configure pluralization
    pluralSeparator: '_',
    contextSeparator: '_',
  });

export default i18n;